import React from 'react'
import { useNavigate } from 'react-router-dom'
import CloseIcon from 'assets/images/rectangle/right-green.svg'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <>
            <div className=" bg-transparent w-full px-4 py-4 flex justify-between sticky top-0 z-10 shadow-[0px 2px 4px 0px #0000001A] items-center">
                <img
                    src={CloseIcon}
                    alt="close"
                    className=" cursor-pointer"
                    onClick={() => navigate(-1)}
                />
                <p className=" text-green-1 text-xl font-black">{title}</p>
                <div className="flex"></div>
            </div>
        </>
    )
}
